import { assetsTreeList } from '@/api/assets'

// 房源选择
export default {
    data() {
        return {
            parkList: [],
        }
    },
    methods: {
        // level 1-园区 2-楼栋 3-楼层
        fetchAssetsPark(level = 2) {
            return assetsTreeList({ pageNo: 1, pageSize: 999, level }).then(
                (res) => {
                    var list = res.data.list

                    list.forEach((v) => {
                        // 默认都展开
                        v.expand = true
                    })

                    return list
                }
            )
        },
    },
}
